import React, { useState, useEffect } from 'react'
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  useLocation,
} from 'react-router-dom'
import Navbar from './components/Navbar'
import Footer from './components/Footer'
import FeedbackForm from './components/FeedbackForm'
import SEOHead, { seoConfigs } from './components/SEOHead'
import ToolsPage from './pages/ToolsPage'
import CompaniesPage from './pages/CompaniesPage'
import ContributorsPage from './pages/ContributorsPage'
import TimelinePage from './pages/TimelinePage'
import BackToTop from './components/BackToTop'

// Component to handle scroll to top on route change
const ScrollToTop = () => {
  const { pathname } = useLocation()

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [pathname])

  return null
}

function App() {
  const [darkMode, setDarkMode] = useState(true) // Default to dark mode

  useEffect(() => {
    // Check for saved theme preference or default to dark mode
    const savedTheme = localStorage.getItem('theme')
    if (savedTheme) {
      setDarkMode(savedTheme === 'dark')
    } else {
      // Default to dark mode if no preference is saved
      setDarkMode(true)
      localStorage.setItem('theme', 'dark')
    }
  }, [])

  useEffect(() => {
    // Apply theme to document
    if (darkMode) {
      document.documentElement.classList.add('dark')
      localStorage.setItem('theme', 'dark')
    } else {
      document.documentElement.classList.remove('dark')
      localStorage.setItem('theme', 'light')
    }
  }, [darkMode])

  const toggleDarkMode = () => {
    setDarkMode(!darkMode)
  }

  return (
    <Router>
      <SEOHead {...seoConfigs.home} />
      <ScrollToTop />
      <div className='min-h-screen gradient-bg'>
        <Navbar darkMode={darkMode} toggleDarkMode={toggleDarkMode} />
        <main className='container mx-auto px-4 py-8'>
          <Routes>
            <Route path='/' element={<Navigate to='/tools' replace />} />
            <Route path='/tools' element={<ToolsPage />} />
            <Route path='/companies' element={<CompaniesPage />} />
            <Route path='/agents' element={<ContributorsPage />} />
            <Route path='/timeline' element={<TimelinePage />} />
          </Routes>
        </main>
        <div id='subscribe'></div>
        {/* Feedback Form */}
        <div className='container mx-auto px-4'>
          <FeedbackForm />
        </div>

        {/* Footer */}
        <Footer />
        {/* Back to Top Button */}
        <BackToTop />
      </div>
    </Router>
  )
}

export default App
